import React, { useState, useEffect } from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import firebase from './../../../firebase';
import { useParams } from 'react-router-dom';
import { Button, Col, Form, Row, Card, Image, Badge, Modal, Alert, ProgressBar, Placeholder } from 'react-bootstrap';

import Select from 'react-select';
import Compressor from "compressorjs";
import { toast } from 'react-toastify';
import FalconCardHeader from 'components/common/FalconCardHeader';
import ProfileBanner from '../user/ProfileBanner';
import GPhotos from 'components/photos/Photos';
import IconButton from 'components/common/IconButton';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { typehome, monthslist } from 'config'
import { ReactSortable } from "react-sortablejs";
import { API_URL } from 'constants';
import { toastr } from 'react-redux-toastr';
import { API_URL_NEW } from 'constants'; 
import logoIcon from 'assets/img/logoIcon.png';



const EditVilla = () => {
    const { id } = useParams();
    const [gallery, setGallery] = React.useState([]);
    const [lphoto, setLPhoto] = React.useState(false);
    const [uploaded, setUploaded] = useState(0);
    const [visibleGallery, setVisibleGallery] = React.useState(false);
    const [newgallery, setNewGallery] = React.useState([]);
    const [valueEquipment, setValueEquipment] = React.useState(null);
    const [valueEquipmentEnAvant, setValueEquipmentEnAvant] = React.useState(null);
    const [equipements, setEquipements] = React.useState([]);
    const [valueContacts, setValueContactsId] = React.useState(null);
    const [valueOTA, setValueOTA] = React.useState(null);
    const [valueType, setValueType] = React.useState(null);
    const [validated, setValidated] = React.useState(false);
    const [valuePer, setValuePer] = React.useState(null);
    const [formd, setFrom] = React.useState({});
    const [prep, setPrep] = React.useState(true);
    const [l, setL] = React.useState(false);
    const [clients, setClients] = React.useState([]);
    const [valueBeforeOwner, setBeforeValueOwner] = React.useState(null);
    const [valueOwner, setValueOwner] = React.useState(null);
    const [gP1, setGP1] = React.useState(null);
    const [lgallery, setLGallery] = React.useState(false);
    const [lfile, setLFile] = React.useState(false);
    const [newfile, setNewFile] = React.useState([]);
    const [newInfofile, setNewInfoFile] = React.useState(null);
    const [files, setFiles] = React.useState([]);

    const [prices, setPrices] = React.useState([]);
    const [services, setServices] = React.useState([]);
    const [disponiblite, setDisponibilite] = React.useState([]);
    const [servicesList, setServicesList] = React.useState([]);
    const [previews, setPreviews] = React.useState([]);
    // Etat pour gérer l'affichage de la modale
    const [showModal, setShowModal] = useState(false);


  const [showBookerMenu, setShowBookerMenu] = useState(null);
  const [users, setUsers] = useState([]);


  const loadUsers = async () => {
    const usersSnapshot = await firebase.firestore().collection('users').get();
    const usersData = [];
    usersSnapshot.forEach(doc => {
      const userData = doc.data();
      if (userData.delete != true && userData.type === 'admin') { 
        usersData.push({ id: doc.id, ...userData });
      }
    });
    setUsers(usersData);
  };

    // Fonction pour ouvrir la modale
    const handleModalShow = () => {
        setPreviews(formd?.previews || []);
        setSelectedPhotos(formd?.previews || []);
        setShowModal(true)

    };

    // Fonction pour fermer la modale
    const handleModalClose = () => setShowModal(false);


    const [selectedPhotos, setSelectedPhotos] = useState([]);

    // Fonction pour gérer la sélection/désélection d'une photo
    const handleSelectPhoto = (photoId) => {
        setSelectedPhotos(prevSelected => {
            if (prevSelected.includes(photoId)) {
                // Si la photo est déjà sélectionnée, on la désélectionne
                return prevSelected.filter(id => id !== photoId);
            } else {
                // Sinon on l'ajoute à la liste des photos sélectionnées
                return [...prevSelected, photoId];
            }
        });
    };


    const [show, setShow] = useState(false);
    const [villas, setVillas] = useState([]);
    const [sync, setSync] = useState(false);
    const [syncPrice, setSyncPrice] = useState(false);
    const [syncPriceDemand, setSyncPriceDemand] = useState(false);
    const [syncCover, setSyncCover] = useState(false);
    const [selectedVilla, setSelectedVilla] = useState("");
    const [syncPhotos, setSyncPhotos] = useState("");

    const [destinations, setDestinations] = useState([]);
    const [destination, setDestination] = useState([]);
    const [location, setLocation] = useState([]);

    const ar = [
        { value: "beach-by-foot", label: "Plage à pieds", critereId: 18799 },
        { value: "sea-view", label: "Vue sur la mer", critereId: 18801 },
        { value: "downtown", label: "Centre ville", critereId: 18800 },
        { value: "countryside", label: "Campagne", critereId: 18802 },
    ]


    const fetchDestinations = async () => {
        try {
            const response = await fetch(API_URL_NEW + "fetchDestinations", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                toastr.error("Erreur serveur")
                throw new Error("Erreur serveur");
            }
            const data = await response.json();
            setDestinations(data);
        } catch (error) {
            toastr.error("Erreur lors de la récupération des destinations")
            console.error("Erreur lors de la récupération des destinations :", error);
        }
    };


    const fetchVillas = async () => {
        try {
            const response = await fetch(API_URL_NEW + "fetchVillas", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                toastr.error("Erreur serveur")
                throw new Error("Erreur serveur");
            }
            const data = await response.json();
            setVillas(data);
        } catch (error) {
            toastr.error("Erreur lors de la récupération des villas")
            console.error("Erreur lors de la récupération des villas :", error);
        }
    };


    useEffect(() => {
        if (show) {
            fetchVillas();
        }
    }, [show]);


    const handleVillaChange = (e) => {
        // console.log('handleVillaChange', e.target.value);
        setSelectedVilla(e.target.value);
        setSyncPhotos(""); // Réinitialise le champ de synchronisation si la villa change
    };

    const handleSyncChange = (e) => {
        setSyncPhotos(e.target.value);
    };

    const handleClose = () => {
        setShow(false);
    };


    const updateG = (ngal) => {
        let nb = []
        ngal?.forEach(l => {
            let m = l;
            delete m.chosen;
            delete m.selected;
            let s = '';
            for (const [key, value] of Object.entries(m)) {
                s += value;
            }
            nb.push(s);
        })
        firebase.firestore().collection('properties').doc(id).update({ gallery: nb }).then((snap) => {
            var f = { ...formd }
            f.gallery = nb
            setFrom(f)
        })

    }



    const loadList = () => {
        // get list clients and format
        firebase.firestore().collection('equiments').get().then((snap) => {
            let s = [];
            snap.forEach((d) => {
                const dr = { value: d.id, label: d.data()?.title, miseenavant: d.data()?.miseenavant || false }
                s.push(dr)
            })
            setEquipements(s);

        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })

        firebase.firestore().collection('services').get().then((snap) => {
            let s = [];
            snap.forEach((d) => {
                let e = '';
                const dr = { value: d.id, label: d.data()?.title }
                s.push(dr)
            })
            setServicesList(s);

        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })
    }


    const getClients = (cb) => {
        // get list clients and format
        firebase.firestore().collection('crm').get().then((snap) => {
            let s = [];
            snap.forEach((d) => {
                let e = '';
                let pre = d.data()?.email?.split(',') || []
                pre.forEach((s) => {
                    e += `${s}, `;
                })
                const dr = { value: d.id, label: `${d.data()?.lastName} ${d.data()?.firstName}`, email: e, property: d.data()?.property || [], picture_profile: d?.data()?.picture_profile || null }
                if (d.data()?.delete) { }
                else {
                    s.push(dr)
                }
            })
            setClients(s);
            cb(s)

        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })

    }


    useEffect(() => {
        if (id) {
            fetchDestinations()
            loadList();
            loadUsers();
            getClients((cl) => {
                firebase.firestore().collection('properties').doc(id).get().then(doc => {
                    if (doc) {
                        let d = doc.data()
                        d.id = doc.id;
                        d.lat = d.localisation?.lat || null
                        d.long = d.localisation?.long || null
                        setFrom(d)
                        if (d.gallery.length > 0 && d.gallery[0] != null) {
                            setGP1(d.gallery[0]);
                            let spd = [];
                            d.gallery?.forEach((s) => {
                                spd.push(s.toString() || s)
                            })
                            setGallery(spd);
                        }
                        d.price = d?.priceStart?.price;
                        setPreviews(d?.previews || [])
                        setValuePer(d?.priceStart?.per)
                        setValueType(d.type);
                        setValueEquipment(d.equipments || []);
                        setValueEquipmentEnAvant(d.equipmentsInFavorites || []);
                        setValueOTA(d.otaIds);
                        setValueContactsId(d.contactsId);
                        setFiles(d?.files || [])
                        setServices(d?.services || []);
                        setDisponibilite(d?.disponibilite || []);
                        if (d?.location?.length > 0) {
                            let ms = [];
                            d?.location.forEach((a) => {
                                if (a.value) {
                                    const m = ar.find((v) => v.value === a.value)
                                    ms.push(m);
                                }
                            })
                            setLocation(ms);
                        } else {
                            setLocation(d?.location || []);
                        }
                        if (d?.prices?.length > 0) {
                            let sp = [];
                            d?.prices.forEach((s) => {
                                let p = s;
                                if (p.periodType === null || p.periodType === undefined) {
                                    p.periodType = { value: 'month', label: 'Par mois' };
                                } 
                                sp.push(p)
                            })
                            setPrices(sp);
                        }

                        // setPrices(d?.prices || []);
                        setSelectedVilla(d?.wp_id || "")
                        setSync(d?.sync || false)
                        setSyncPrice(d?.syncPrice || false)
                        setSyncPriceDemand(d?.syncPriceDemand || false)
                        setSyncPhotos(d.syncPhotos || "")
                        setSyncCover(d?.syncCover || false)
                        setDestination(d.destination || [])
                        if (valueOwner === null && cl.length > 0 && d?.ownerId !== null && d?.ownerId !== undefined) {
                            cl.forEach((c) => {
                                if (d.ownerId === c.value) {
                                    setValueOwner(c)
                                    setBeforeValueOwner(c);
                                }
                            })
                        }

                        setPrep(false)

                    }
                })
            });

        } else {
            toast.error('Une erreur s\'est produite.');
        }
    }, []);

    const handleChange = e => {
        let d = { ...formd };

        d[e.target.name] = e.target.value;

        if (e.target.name === 'show_parter') {
            d[e.target.name] = e.target.checked;
        }
        setFrom(d);
    };

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        // console.log(formd)
        if (form.checkValidity() === false) {
            toast.warning("Veuillez remplir les champs obligatoire")
            return;
        }

        if (l) {
            return;
        }

        var t = { ...formd }
        t._update_At = new Date();

        t.localisation = {
            lat: formd.lat,
            long: formd.long
        }

        // t.priceStart = {
        //     per : valuePer, 
        //     price : Number(formd.price)
        // } 

        if (newInfofile != null) {
            if (newInfofile.length > 0) {
                setLFile(true);
                Array.from(newInfofile).forEach(async (n) => {
                    await sendFile(n, async (downloadURL) => {
                        try {
                            firebase.firestore().collection('properties').doc(id).update({ newInfofile: downloadURL }).then(() => {
                                console.log("Document successfully written!");
                                toast.success("Fiche d'information ajoutée avec succès");
                                setNewInfoFile(null);
                                var f = { ...formd }
                                f.newInfofile = downloadURL
                                setFrom(f)
                                setLFile(false)
                            }).catch((error) => {
                                setL(false);
                                var errorMessage = error.message;
                                toast.error(errorMessage);
                                setLFile(false)
                            })
                        } catch (error) {
                            setLFile(false)
                            var errorMessage = error.message;
                            toast.error(errorMessage);
                        }
                    })
                })
            }
        }

        setValidated(true);
        if (t.type) {
            // réassocié l'identifiant du type de bien
            t.type = typehome.find((d) => d.value === t.type.value);
        }
        if (destination) {
            t.destination = destination;
        }
        if (location) {
            t.location = location;
        }
        const sortedData1 = equipements.sort((a, b) => {
            return b.miseenavant - a.miseenavant;
        });
        // console.log('sortedData1', sortedData1)
        let m = [];
        sortedData1.forEach((s) => {
            valueEquipment?.forEach(er => {
                if (s.value === er.value) {
                    m.push(er)
                }
            });
        })

        t.equipments = m.sort((a, b) => a?.miseenavant - b?.miseenavant);

        delete t.id
        delete t._create_At;
        delete t.lat;
        delete t.long;
        delete t.price;
        delete t.equipements;
        delete t.hasMerge;
        if (valueOwner && valueOwner?.value !== valueBeforeOwner?.value) {
            t.ownerId = valueOwner.value
        }
        t.wp_id = selectedVilla; // identifiant de la villa 
        t.syncPhotos = syncPhotos;
        t.syncPrice = syncPrice;
        t.syncPriceDemand = syncPriceDemand;
        t.syncCover = syncCover;
        t.sync = sync;

        if (t.sync && t.wp_id) {
            t.update_wp_status = null;
        }
        let nb = []
        t?.previews?.forEach(l => {
            let m = l;
            delete m.chosen;
            delete m.selected;
            let s = '';
            for (const [key, value] of Object.entries(m)) {
                s += value;
            }
            if (nb.length <= 5) {
                nb.push(s);
            }

        })
        t.previews = Array.isArray(nb) ? nb.slice(0, 5) : [];
        // const filteredT = Object.fromEntries(
        //     Object.entries(t).filter(([key]) => isNaN(key))
        // );
        // console.log('t', filteredT);
        // return;
        setL(true);
        try {
            firebase.firestore().collection('properties').doc(id).update(t).then(async () => {
                console.log("Document successfully written!");
                toast.success("Propriété modifié avec succès");
                //  a retirer en prod
                if (t.sync && selectedVilla != "") {
                    toast.warning("La synchonisation est en cours en arrière plan")
                    const verify = firebase.functions().httpsCallable("testWpSync");
                    const v = await verify({ propertyId: id });
                    // console.log('v', v)
                }

                setL(false);
                if (t?.ownerId) {
                    clients?.forEach((c) => {
                        // retirer l'ancien owner l'id de la villa

                        if (valueBeforeOwner?.value && c.value === valueBeforeOwner?.value) {
                            let npropertylist = []
                            c.property?.forEach((sd) => {
                                if (sd?.value !== id) {
                                    npropertylist.push(sd)
                                }
                            })
                            firebase.firestore()
                                .collection('crm')
                                .doc(valueBeforeOwner?.value)
                                .update({ property: npropertylist, is_owner: npropertylist?.length > 0 ? true : false, update_At: new Date() })

                        }
                        //ajouter le nouveau propriétaire 
                        if (valueOwner?.value && c.value === valueOwner?.value) {
                            let npropertylist = c.property || [];
                            npropertylist.push({ value: id, label: t.nameHouse })
                            firebase.firestore()
                                .collection('crm')
                                .doc(valueOwner?.value)
                                .update({ property: npropertylist, is_owner: true, update_At: new Date() }).then(() => {
                                    setBeforeValueOwner(valueOwner)
                                })
                        }
                    })

                }
            }).catch((error) => {
                setL(false);
                var errorMessage = error.message;
                toast.error(errorMessage);
            })
        } catch (error) {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        }
    };

    const characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    function generateString(length) {
        let result = '';
        const charactersLength = characters.length;
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }

        return result;
    }

    const sendFile = async (file, cb) => {
        const storage = firebase.storage();
        const metadata = {
            contentType: file.type,
        };
        const ss = `files/${generateString(10)}.${file?.type?.split("/")[1]}`;
        const reference = storage.ref(ss);
        if (file.type?.includes('image')) {
            console.log('file', file);
            try {
                new Compressor(file, {
                    maxHeight: 1300,
                    quality: 0.9, // 0.6 can also be used, but its not recommended to go below.
                    success: (compressedResult) => {
                        // compressedResult has the compressed file.
                        // Use the compressed file to upload the images to your server.
                        const uploadTask = reference.put(compressedResult, metadata);

                        uploadTask.on(
                            firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
                            (snapshot) => {
                                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                                var progress =
                                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                console.log(`Upload is ${progress}% done`);
                                switch (snapshot.state) {
                                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                                        console.log("Upload is paused");
                                        break;
                                    case firebase.storage.TaskState.RUNNING: // or 'running'
                                        console.log("Upload is running");
                                        break;
                                    default:
                                        break;
                                }
                            },
                            (err) => {
                                // A full list of error codes is available at
                                // https://firebase.google.com/docs/storage/web/handle-errors
                                switch (err.code) {
                                    case "storage/unauthorized":
                                        // User doesn't have permission to access the object
                                        alert(
                                            "Une erreur est survenue lors de l'envoie de votre logo, vous n'avez pas l'autorisation d'envoyez des images."
                                        );
                                        break;
                                    case "storage/canceled":
                                        // User canceled the upload alert(
                                        alert(
                                            "Une erreur est survenue lors de l'envoie de votre logo, vous avez annuler l'envoie."
                                        );
                                        break;

                                    // ...

                                    case "storage/unknown":
                                        // Unknown error occurred, inspect error.serverResponse
                                        alert(
                                            "Une erreur est survenue lors de l'envoie de votre logo, réessayer plus tard."
                                        );
                                        break;
                                    default:
                                        break;
                                }
                            },
                            () => {
                                console.log("Image uploaded to the bucket!");



                                uploadTask.snapshot.ref
                                    .getDownloadURL()
                                    .then(async (downloadURL) => {
                                        cb(downloadURL)
                                    });



                            }
                        );
                    },
                    error: (error) => {
                        console.log('error', error)
                        toast.error(`${file.name} une erreur c'est produite avec ce fichier`);
                        cb(null)
                    }
                });
            } catch (err) {
                console.error('error', err)
                toast.error(`${file.name} une erreur c'est produite avec ce fichier`);
                cb(null)
            }
        } else {
            const uploadTask = reference.put(file, metadata);

            uploadTask.on(
                firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
                (snapshot) => {
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    var progress =
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log(`Upload is ${progress}% done`);
                    switch (snapshot.state) {
                        case firebase.storage.TaskState.PAUSED: // or 'paused'
                            console.log("Upload is paused");
                            break;
                        case firebase.storage.TaskState.RUNNING: // or 'running'
                            console.log("Upload is running");
                            break;
                        default:
                            break;
                    }
                },
                (err) => {
                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    switch (err.code) {
                        case "storage/unauthorized":
                            console.error("err", err)
                            // User doesn't have permission to access the object
                            alert(
                                "Une erreur est survenue lors de l'envoie de votre fichier, vous n'avez pas l'autorisation d'envoyez des documents."
                            );
                            break;
                        case "storage/canceled":
                            // User canceled the upload alert(
                            alert(
                                "Une erreur est survenue lors de l'envoie de votre fichier, vous avez annuler l'envoie."
                            );
                            break;

                        // ...

                        case "storage/unknown":
                            // Unknown error occurred, inspect error.serverResponse
                            alert(
                                "Une erreur est survenue lors de l'envoie de votre fichier, réessayer plus tard."
                            );
                            break;
                        default:
                            break;
                    }
                },
                () => {
                    console.log("Image uploaded to the bucket!");



                    uploadTask.snapshot.ref
                        .getDownloadURL()
                        .then(async (downloadURL) => {
                            cb(downloadURL)
                        });
                }
            );
        }




    };

    const handleSubmitFile = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (newfile.length > 0) {
            var ng = files;
            var index = 0;
            setLFile(true);

            Array.from(newfile).forEach(async (n) => {
                await sendFile(n, async (downloadURL) => {
                    ng.push(downloadURL)
                    index += 1;
                    if (index === newfile.length) {
                        try {
                            firebase.firestore().collection('properties').doc(id).update({ files: ng }).then(() => {
                                console.log("Document successfully written!");
                                toast.success("Fichier(s) ajoutée avec succès");
                                setNewFile([]);
                                setFiles(ng);
                                var f = { ...formd }
                                f.files = ng
                                setFrom(f)
                                console.log("ng", ng);
                                setLFile(false)
                            }).catch((error) => {
                                setL(false);
                                var errorMessage = error.message;
                                toast.error(errorMessage);
                                setLFile(false)
                            })
                        } catch (error) {
                            setLFile(false)
                            var errorMessage = error.message;
                            toast.error(errorMessage);
                        }
                    }
                })
            })

        }
    }
    const progress = (uploaded / Array.from(newgallery).length) * 100;
    const handleSubmitPicture = (event) => {
        event.preventDefault();
        event.stopPropagation();


        if (newgallery.length > 0) {
            let ng = [];
            gallery?.forEach((s) => {
                ng.push(s.toString() || s)
            })

            var index = 0
            setUploaded(index)
            setLPhoto(true);
            Array.from(newgallery).forEach(async (n) => {
                await sendFile(n, async (downloadURL) => {
                    if (downloadURL) {
                        ng.push(downloadURL?.toString() || downloadURL)
                    }
                    index += 1;
                    console.log('index', index)
                    setUploaded(index)
                    if (index === newgallery.length && ng.length > 0) {
                        try {
                            firebase.firestore().collection('properties').doc(id).update({ gallery: ng }).then(() => {
                                console.log("Document successfully written!");
                                toast.success("Photo(s) ajoutée avec succès");
                                setNewGallery([]);
                                setGallery(ng);
                                var f = { ...formd }
                                f.gallery = ng
                                setFrom(f)
                                setLPhoto(false)
                            }).catch((error) => {
                                setL(false);
                                var errorMessage = error.message;
                                toast.error(errorMessage);
                                setLPhoto(false)
                            })
                        } catch (error) {
                            setLPhoto(false)
                            var errorMessage = error.message;
                            toast.error(errorMessage);
                        }
                    }
                })
            })

        }
    }

    const delFile = (index) => {
        if (confirm(`Êtes vous certain de vouloir supprimer le fichier?`)) {
            let b = []
            files.forEach((c, i) => {
                if (i !== index) {
                    b.push(c)
                }
            })
            setLFile(true);


            try {
                firebase.firestore().collection('properties').doc(id).update({ files: b }).then((snap) => {

                    setLFile(false);
                    var f = { ...formd }
                    f.files = b
                    setFrom(f)
                    setFiles(b);

                    toast.success("Suppression effectué");
                })
            } catch (err) {
                setLFile(false);
                // eslint-disable-next-line no-console
                console.log(err);
                toast.error("Une erreur s'est produite");
            }

        }
    }

    const delImage = (index) => {
        // supprimer
        // gallery

        if (confirm(`Êtes vous certain de vouloir supprimer la photo?`)) {
            let b = []
            // console.log('gallery', gallery)
            gallery.forEach((c, i) => {
                if (i !== index) {
                    // console.log(c.toString())
                    b.push(c?.toString() || c)
                }
            })
            // console.log('b', b)
            setLGallery(true);
            setLPhoto(true)


            try {
                firebase.firestore().collection('properties').doc(id).update({ gallery: b }).then((snap) => {

                    setLGallery(false);
                    var f = { ...formd }
                    f.gallery = b
                    setFrom(f)
                    setGallery(b);
                    setLPhoto(false)

                    toast.success("Suppression effectué");
                })
            } catch (err) {
                setL(false);
                // eslint-disable-next-line no-console
                console.log(err);
                toast.error("Une erreur s'est produite");
            }

        }

    }
    const [caA, setCAA] = useState(false)
    const creatandAsign = () => {
        if (caA) {
            return
        }
        if (confirm(`Êtes vous certain de vouloir créer un nouveau calendrier google et y assigné la villa?`)) {

            setCAA(true)
            fetch(`${API_URL}creatcalendar`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: id, nameHouse: formd.nameHouse }),
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.success) {
                        toast.success('Nouveau calendrier google assigné')
                        window.location.reload()
                    }
                    setCAA(false)
                }).catch((err) => {
                    setCAA(false)
                    toast.error(err.message)
                })
        }

    }

    return (
        <FalconComponentCard>
            {
                prep ? <p style={{ margin: 10 }}>Chargement ....</p> : (<>
                    {gP1 && (
                        <ProfileBanner>
                            <ProfileBanner.Header
                                coverSrc={gP1}
                                avatar={valueBeforeOwner?.picture_profile}
                                className="mb-1" />
                        </ProfileBanner>
                    )}

                    <FalconComponentCard.Header title={`Edition de la propriété - ${id}`} light={false} noPreview={true} />
                    <Col xs="auto" style={{ padding: 20 }}>
                        {
                            (formd.fhsId === null || formd.fhsId === undefined || formd.fhsId.length === 0) && (
                                <IconButton onClick={() => {
                                    window.location.href = `https://fabiohome-1.web.app/api?api_key=fG7LwR2BzN5q8TdYX6pVQKj3CmAH9Ws4&nameHouse=${formd.nameHouse}&id=${formd.id}&return_url=https://bo-house.software/connect`;
                                }}
                                    variant="falcon-link"
                                    size="sm"
                                    icon="link"
                                    transform="shrink-3"
                                    className='me-2'
                                >
                                    Connexion avec FHS
                                </IconButton>
                            )
                        }
                        <IconButton href={`/villa/edit/${id}/fichemaison`}
                            variant="falcon-primary"
                            size="sm"
                            icon="home"
                            transform="shrink-3"
                            className='me-2'
                        >Fiche maison</IconButton>

                        <IconButton href={`/villa/edit/${id}/fichecontact`}
                            variant="falcon-primary"
                            size="sm"
                            icon="message"
                            transform="shrink-3"
                            className='me-2'
                        >Fiche contact</IconButton>
                        <IconButton target="_blank" href={`/v/${id}`}
                            variant="falcon-primary"
                            size="sm"
                            icon="eye"
                            transform="shrink-3"
                            className='me-2'
                        >Voir la fiche descriptive</IconButton>
                        <div style={{ display: 'inline-block', marginRight: '10px', position: 'relative' }}>
                        <IconButton
                        variant="falcon-link"
                        size="sm"
                        className="avatar-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            if (showBookerMenu === id) {
                                setShowBookerMenu(null);
                            }else{
                                setShowBookerMenu(id);
                            }
                            
                        }}
                        >
                        {formd.bookerId ? (
                            <>
                            <img 
                            src={users.find(u => u.id === formd.bookerId)?.picture_profile || logoIcon} 
                            alt="Booker" 
                            style={{ width: '24px', height: '24px', borderRadius: '50%' }}
                            />
                            <span> {users.find(u => u.id === formd.bookerId)?.firstName} {users.find(u => u.id === formd.bookerId)?.lastName}</span>
                            </>
                        ) : (
                            <FontAwesomeIcon icon="user-circle" />
                        )}
                        </IconButton>
                        
                        {showBookerMenu === id && (
                        <div 
                            style={{
                            position: 'absolute',
                            top: '100%',
                            right: 0,
                            backgroundColor: 'white',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            zIndex: 1000,
                            minWidth: '200px'
                            }}
                        >
                            {users.map(user => (
                            <div
                                key={user.id}
                                onClick={() => {
                                    firebase.firestore().collection('properties').doc(id).update({
                                        bookerId: user.id
                                    }).finally(() => {
                                        setFrom({...formd, bookerId: user.id})
                                        setShowBookerMenu(null);
                                    }) 
                                }}
                                style={{
                                padding: '8px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                                }}
                            >
                                <img 
                                src={user.picture_profile || logoIcon} 
                                alt={user.firstName} 
                                style={{ width: '24px', height: '24px', borderRadius: '50%' }}
                                />
                                <span>{user.firstName} {user.lastName}</span>
                            </div>
                            ))}
                        </div>
                        )}
                    </div> 
                    </Col>
                    <FalconComponentCard.Body >
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>

                            <Row className="mb-3">
                                <Form.Group as={Col} md="4" controlId="nameHouse">
                                    <Form.Label>Nom de la propriété <Badge>wordpress</Badge></Form.Label>
                                    <Form.Control
                                        required
                                        type="text"
                                        value={formd.nameHouse}
                                        name="nameHouse"
                                        onChange={handleChange}
                                        placeholder="Nom de la propriété ..."
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="5" controlId="villa">
                                    <Form.Label>Propriétaire</Form.Label>
                                    <Select
                                        // closeMenuOnSelect={false}
                                        required
                                        // isDisabled={true}
                                        options={clients}
                                        placeholder='Choisir le propriétaire...'
                                        classNamePrefix="react-select"
                                        value={valueOwner}
                                        onChange={value => {
                                            setValueOwner(value)
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group as={Col} md="3">
                                    <Form.Label>Espace partenaire</Form.Label>
                                    <Form.Check
                                        type="switch"
                                        name="show_parter"
                                        onChange={handleChange}
                                        label="Afficher pour les partenaires"
                                        checked={formd.show_parter}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="8" controlId="fhsId">
                                    <Form.Label>Identifiant interne FHS</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formd.fhsId}
                                        name="fhsId"
                                        onChange={handleChange}
                                        placeholder="Demander l'identifiant de cette villa au développeur si elle existe..."
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="adresse">
                                    <Form.Label>Adresse</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formd.adresse}
                                        name="adresse"
                                        onChange={handleChange}
                                        placeholder="Adresse ..."
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="2" controlId="city">
                                    <Form.Label>Ville <Badge>wordpress</Badge></Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formd.city}
                                        name="city"
                                        onChange={handleChange}
                                        placeholder="Ville ..."
                                    />
                                </Form.Group>

                                <Form.Group as={Col} md="1" controlId="zipcode">
                                    <Form.Label>Code postale</Form.Label>
                                    <Form.Control
                                        minlength="5"
                                        type="text"
                                        value={formd.zipcode}
                                        name="zipcode"
                                        onChange={handleChange}
                                        placeholder="Code postale ..."
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="2" className="mb-3">
                                    <Form.Label>Destinations <Badge>New (wordpress)</Badge></Form.Label>
                                    {destinations.length > 0 ? (<Select

                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={destinations}
                                        placeholder='Choisir...'
                                        classNamePrefix="react-select"
                                        value={destination}
                                        onChange={(value) => {
                                            setDestination(value);
                                            let d = formd;
                                            d['destination'] = value;
                                            setFrom(d);
                                        }}
                                    />) : (<p>Chargement</p>)}

                                </Form.Group>


                                <Form.Group as={Col} md="10" controlId="complement">
                                    <Form.Label>Complément d'adresse</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formd.complement}
                                        name="complement"
                                        onChange={handleChange}
                                        placeholder="Complément d'adresse ..."
                                    />
                                </Form.Group>

                                <Form.Group as={Col} md="3" controlId="quatier">
                                    <Form.Label>Quartier</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formd?.quartier}
                                        name="quartier"
                                        onChange={handleChange}
                                        placeholder="Quartier de la location ..."
                                    />
                                </Form.Group>

                                <Form.Group as={Col} md="2" className="mb-3">
                                    <Form.Label>Location <Badge>New (wordpress)</Badge></Form.Label>
                                    <Select

                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={ar}
                                        placeholder='Choisir...'
                                        classNamePrefix="react-select"
                                        value={location}
                                        onChange={(value) => {
                                            setLocation(value);
                                            let d = formd;
                                            d['location'] = value;
                                            setFrom(d);
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group as={Col} md="2" controlId="m2">
                                    <Form.Label>m2 (terrain) <Badge>wordpress</Badge></Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={formd.m2}
                                        name="m2"
                                        onChange={handleChange}
                                        placeholder="Surface en m2 ..."
                                    />
                                </Form.Group>


                                <Form.Group as={Col} md="2" controlId="m2">
                                    <Form.Label>m2 (habitable)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={formd.m2habitable}
                                        name="m2habitable"
                                        onChange={handleChange}
                                        placeholder="Surface en m2 ..."
                                    />
                                </Form.Group>

                                <Form.Group as={Col} md="2" controlId="nbRooms">
                                    <Form.Label>Nombre de chambres <Badge>wordpress</Badge></Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={formd.nbRooms}
                                        name="nbRooms"
                                        onChange={handleChange}
                                        placeholder="Nombre de chambres ..."
                                    />
                                </Form.Group>


                                <Form.Group as={Col} md="2" controlId="nbBath">
                                    <Form.Label>Nombre de Salle d'eau <Badge>wordpress</Badge></Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={formd.nbBath}
                                        name="nbBath"
                                        onChange={handleChange}
                                        placeholder="Nombre de Salle de bain ..."
                                    />
                                </Form.Group>

                                <Form.Group as={Col} md="2" controlId="maxGuest">
                                    <Form.Label>Nbr d'invité max <Badge>wordpress</Badge></Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={formd.maxGuest}
                                        name="maxGuest"
                                        onChange={handleChange}
                                        placeholder="Inviter max..."
                                    />
                                </Form.Group>


                                <Form.Group as={Col} md="3" controlId="type">
                                    <Form.Label>Type de bien <Badge>wordpress</Badge></Form.Label>
                                    <Select
                                        closeMenuOnSelect={false}
                                        required
                                        options={typehome}
                                        placeholder='Choisir...'
                                        classNamePrefix="react-select"
                                        value={valueType}
                                        onChange={value => {
                                            setValueType(value)
                                            let d = formd;
                                            d['type'] = value;
                                            setFrom(d);

                                        }}
                                    />
                                </Form.Group>


                                <Form.Group as={Col} md="3" controlId="exposition">
                                    <Form.Label>Exposition</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formd.exposition}
                                        name="exposition"
                                        onChange={handleChange}
                                        placeholder="Sud, Est ..."
                                    />
                                </Form.Group>


                                <Form.Group as={Col} md="7" controlId="distance">
                                    <Form.Label>DISTANCE DE LA LOCATION par rapport aux principaux équipements et centres d’intérêt (km)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formd.distance}
                                        name="distance"
                                        onChange={handleChange}
                                        placeholder="3 km"
                                    />
                                </Form.Group>


                                <Form.Group as={Col} md="3" controlId="vue">
                                    <Form.Label>Vue</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formd.vue}
                                        name="vue"
                                        onChange={handleChange}
                                        placeholder="Dégagée"
                                    />
                                </Form.Group>

                                <Form.Group as={Col} md="3" controlId="vue">
                                    <Form.Label>Lien video (url link) <Badge bg='danger'>NOUVEAU</Badge></Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={formd.urllink}
                                        name="urllink"
                                        onChange={handleChange}
                                        placeholder="https://youtu.be/122334YD_URL_ADDRESS"
                                    />
                                </Form.Group>





                                <hr style={{ marginTop: 10 }} />


                                <Row className="mb-3">
                                    <Form.Label>Tarifications <Badge>wordpress</Badge></Form.Label>
                                    {
                                        prices?.map((price, index) => {
                                            return (<Row className="mb-3">
                                                {/* <Form.Group as={Col} md="4" className="mb-3">
                                                    <Form.Label>Mois</Form.Label>
                                                    <Select
                                                        required
                                                        isMulti
                                                        closeMenuOnSelect={false}
                                                        options={monthslist}
                                                        placeholder='Choisir...'
                                                        classNamePrefix="react-select"
                                                        value={price?.months}
                                                        onChange={(value) => {
                                                            let o = [...prices];
                                                            let m = { ...price };
                                                            m.months = value
                                                            o[index] = m;
                                                            setPrices(o);
                                                            let d = { ...formd };
                                                            d['prices'] = o;
                                                            setFrom(d);
                                                        }}
                                                    />

                                                </Form.Group> */}

<Form.Group as={Col} md="2" className="mb-3">
                                                    <Form.Label>Type de période</Form.Label>
                                                    <Select
                                                        required
                                                        options={[
                                                            { value: 'month', label: 'Par mois' },
                                                            { value: 'date', label: 'Par période' }
                                                        ]}
                                                        placeholder='Choisir...'
                                                        classNamePrefix="react-select"
                                                        value={price?.periodType || { value: 'month', label: 'Par mois' }}
                                                        onChange={(value) => {
                                                            let o = [...prices];
                                                            let m = { ...price };
                                                            m.periodType = value;
                                                            m.months = value.value === 'month' ? m.months : null;
                                                            m.dateRange = value.value === 'date' ? m.dateRange || {} : null;
                                                            o[index] = m;
                                                            setPrices(o);
                                                            let d = { ...formd };
                                                            d['prices'] = o;
                                                            setFrom(d);
                                                        }}
                                                    />
                                                </Form.Group>

                                                {price?.periodType?.value === 'month' ? (
                                                    <Form.Group as={Col} md="4" className="mb-3">
                                                        <Form.Label>Mois</Form.Label>
                                                        <Select
                                                            required
                                                            isMulti
                                                            closeMenuOnSelect={false}
                                                            options={monthslist}
                                                            placeholder='Choisir...'
                                                            classNamePrefix="react-select"
                                                            value={price?.months}
                                                            onChange={(value) => {
                                                                let o = [...prices];
                                                                let m = { ...price };
                                                                m.months = value;
                                                                o[index] = m;
                                                                setPrices(o);
                                                                let d = { ...formd };
                                                                d['prices'] = o;
                                                                setFrom(d);
                                                            }}
                                                        />
                                                    </Form.Group>
                                                ) : (
                                                    <>
                                                        <Form.Group as={Col} md="2" className="mb-3">
                                                            <Form.Label>Date de début</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="date"
                                                                value={price?.dateRange?.start || ''}
                                                                onChange={(e) => {
                                                                    let o = [...prices];
                                                                    let m = { ...price };
                                                                    m.dateRange = { ...m.dateRange, start: e.target.value };
                                                                    o[index] = m;
                                                                    setPrices(o);
                                                                    let d = { ...formd };
                                                                    d['prices'] = o;
                                                                    setFrom(d);
                                                                }}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} md="2" className="mb-3">
                                                            <Form.Label>Date de fin</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="date"
                                                                value={price?.dateRange?.end || ''}
                                                                onChange={(e) => {
                                                                    let o = [...prices];
                                                                    let m = { ...price };
                                                                    m.dateRange = { ...m.dateRange, end: e.target.value };
                                                                    o[index] = m;
                                                                    setPrices(o);
                                                                    let d = { ...formd };
                                                                    d['prices'] = o;
                                                                    setFrom(d);
                                                                }}
                                                            />
                                                        </Form.Group>
                                                    </>
                                                )}

                                                <Form.Group as={Col} md="2" controlId="price">
                                                    <Form.Label>Prix</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={price?.price}
                                                        name={`pricePrice_${index}`}
                                                        onChange={(e) => {
                                                            let o = [...prices];
                                                            let m = { ...price };
                                                            m.price = e.target.value
                                                            o[index] = m;
                                                            setPrices(o);
                                                            let d = { ...formd };
                                                            d['prices'] = o;
                                                            setFrom(d);
                                                        }}
                                                        placeholder="Prix ..."
                                                    />
                                                </Form.Group>


                                                {/* <Form.Group as={Col} md="3" controlId="pricePer">
                                                    <Form.Label>Par</Form.Label>
                                                    <Select
                                                        required
                                                        options={[
                                                            { value: 'week', label: 'Semaine' },
                                                            { value: 'month', label: 'Mois' },
                                                        ]}
                                                        placeholder='Choisir...'
                                                        classNamePrefix="react-select"
                                                        value={price?.per}
                                                        onChange={(value) => {
                                                            let o = [...prices];
                                                            let m = { ...price };
                                                            m.per = value
                                                            o[index] = m;
                                                            setPrices(o);
                                                            let d = { ...formd };
                                                            d['prices'] = o;
                                                            setFrom(d);
                                                        }}
                                                    />
                                                </Form.Group> */}

                                                <IconButton as={Col} md="1" onClick={() => {
                                                    let arr = prices;
                                                    arr.splice(index, 1);
                                                    setPrices(arr);
                                                    let d = { ...formd };
                                                    d['prices'] = arr;
                                                    setFrom(d);
                                                }}
                                                    variant="falcon-danger"
                                                    size="sm"
                                                    icon="trash"
                                                    transform="shrink-3"
                                                    className='me-2'
                                                    style={{ width: 60, height: 25, marginTop: 35 }}
                                                >
                                                </IconButton>
                                            </Row>)
                                        })
                                    }

                                    <div>
                                        <Flex
                                            alignItems="center"
                                            className="mb-4 text-primary cursor-pointer fs-0"
                                            onClick={() => {
                                                let o = [...prices];
                                                if (((o[o.length - 1]?.months?.length > 0 || o[o.length - 1]?.periodType.value !== 'month' ) && o[o.length - 1]?.price?.trim() !== "") || o.length === 0) {
                                                    o.push({ periodType: { value: 'month', label: 'Par mois' },
                                                        months: [] | null,  // for monthly selection
                                                        dateRange: { start: '', end: '' } ,
                                                         price: "",
                                                         per:  { value: 'week', label: 'Semaine' }
                                                    });
                                                    setPrices(o);
                                                }
                                            }}
                                        >
                                            <span className="circle-dashed">
                                                <FontAwesomeIcon icon="plus" />
                                            </span>
                                            <span className="ms-3">Ajouter un nouveau tarif</span>
                                        </Flex>
                                    </div>




                                </Row>

                                <hr style={{ marginTop: 10 }} />


                                <Row className="mb-3">
                                    <Form.Label>Services</Form.Label>
                                    {
                                        services?.map((service, index) => {
                                            return (<Row className="mb-3">



                                                <Form.Group as={Col} md="2" controlId="pricePer">
                                                    <Form.Label>Service</Form.Label>
                                                    <Select
                                                        required
                                                        options={
                                                            servicesList
                                                        }
                                                        placeholder='Choisir...'
                                                        classNamePrefix="react-select"
                                                        value={service?.service}
                                                        onChange={(value) => {
                                                            let o = [...services];
                                                            let m = { ...service };
                                                            m.service = value
                                                            o[index] = m;
                                                            setServices(o);
                                                            let d = { ...formd };
                                                            d['services'] = o;
                                                            setFrom(d);
                                                        }}
                                                    />
                                                </Form.Group>
                                                <Form.Group as={Col} md="3" className="mb-3">
                                                    <Form.Label>Titre</Form.Label>
                                                    <Form.Control
                                                        name={`serviceTitle_${index}`}
                                                        placeholder="Titre"
                                                        value={service.title}
                                                        onChange={(e) => {
                                                            let o = [...services];
                                                            let m = { ...service };
                                                            m.title = e.target.value
                                                            o[index] = m;
                                                            setServices(o);
                                                            let d = { ...formd };
                                                            d['services'] = o;
                                                            setFrom(d);
                                                        }}
                                                    />
                                                </Form.Group>

                                                <Form.Group as={Col} md="2" controlId="category">
                                                    <Form.Label>Catégorie (requis)</Form.Label>
                                                    <Select
                                                        closeMenuOnSelect={true}
                                                        required
                                                        options={[
                                                            { value: 'included', label: 'Inclus' },
                                                            { value: 'not-included', label: 'Non inclus' },
                                                        ]}
                                                        placeholder='Choisir la categorie...'
                                                        classNamePrefix="react-select"
                                                        value={service?.category}
                                                        onChange={value => {
                                                            let o = [...services];
                                                            let m = { ...service };
                                                            m.category = value
                                                            o[index] = m;
                                                            setServices(o);
                                                            let d = { ...formd };
                                                            d['services'] = o;
                                                            setFrom(d);
                                                        }}
                                                    />

                                                </Form.Group>

                                                <Form.Group as={Col} md="4" controlId="description">
                                                    <Form.Label>Description</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={service?.description}
                                                        name={`serviceDescription_${index}`}
                                                        onChange={(e) => {
                                                            let o = [...services];
                                                            let m = { ...service };
                                                            m.description = e.target.value
                                                            o[index] = m;
                                                            setServices(o);
                                                            let d = { ...formd };
                                                            d['services'] = o;
                                                            setFrom(d);
                                                        }}
                                                        placeholder="Description du service ..."
                                                    />
                                                </Form.Group>
                                                <Form.Group as={Col} md="4" controlId="description">
                                                    <Form.Label>Description Englais</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={service?.descriptionEn}
                                                        name={`serviceDescriptionEn_${index}`}
                                                        onChange={(e) => {
                                                            let o = [...services];
                                                            let m = { ...service };
                                                            m.descriptionEn = e.target.value
                                                            o[index] = m;
                                                            setServices(o);
                                                            let d = { ...formd };
                                                            d['services'] = o;
                                                            setFrom(d);
                                                        }}
                                                        placeholder="Description du service (englais)..."
                                                    />
                                                </Form.Group>


                                                <IconButton as={Col} md="1" onClick={() => {
                                                    let arr = services;
                                                    arr.splice(index, 1);
                                                    setServices(arr);
                                                    let d = { ...formd };
                                                    d['services'] = arr;
                                                    setFrom(d);
                                                }}
                                                    variant="falcon-danger"
                                                    size="sm"
                                                    icon="trash"
                                                    transform="shrink-3"
                                                    className='me-2'
                                                    style={{ width: 60, height: 25, marginTop: 35 }}
                                                >
                                                </IconButton>
                                            </Row>)
                                        })
                                    }

                                    <div>
                                        <Flex
                                            alignItems="center"
                                            className="mb-4 text-primary cursor-pointer fs-0"
                                            onClick={() => {
                                                let o = [...services];
                                                if (o[o.length - 1]?.title?.trim() !== "" && o[o.length - 1]?.description?.trim() !== "") {
                                                    o.push({ service: null, title: "", description: "", descriptionEn: "" });
                                                    setServices(o);
                                                }
                                            }}
                                        >
                                            <span className="circle-dashed">
                                                <FontAwesomeIcon icon="plus" />
                                            </span>
                                            <span className="ms-3">Ajouter un nouveau service</span>
                                        </Flex>
                                    </div>

                                    {services[services.length - 1]?.service === null && (
                                        <Form.Text className="text-warning fs--1">
                                            <p>pas dans la liste, <a target="_blank" href="/service/new">Ajouté</a> <IconButton
                                                variant="falcon-default"
                                                size="sm"
                                                icon="reload"
                                                className="me-1 mb-2 mb-sm-0"
                                                iconClassName="me-1"
                                                onClick={() => { loadList() }}>
                                                recharger la liste des services
                                            </IconButton></p>


                                        </Form.Text>
                                    )}



                                </Row>


                                <hr style={{ marginTop: 10 }} />


                                <Row className="mb-3">
                                    <Form.Label>Période de disponiblité</Form.Label>
                                    {
                                        disponiblite?.map((disp, index) => {
                                            return (<Row className="mb-3">



                                                <Form.Group as={Col} md="3" controlId="first">
                                                    <Form.Label>Début</Form.Label>



                                                    <Form.Control required
                                                        name="first"
                                                        type="date"
                                                        value={disp?.first}
                                                        onChange={(e) => {
                                                            // console.log('first', e.target?.value) 
                                                            let o = [...disponiblite];
                                                            let m = { ...disp };
                                                            m.first = e.target?.value
                                                            o[index] = m;
                                                            setDisponibilite(o);
                                                            let d = { ...formd };
                                                            d['disponibilite'] = o;
                                                            setFrom(d);
                                                        }} placeholder='Choisir...' />
                                                </Form.Group>

                                                <Form.Group as={Col} md="3" controlId="end">
                                                    <Form.Label>Fin</Form.Label>



                                                    <Form.Control required
                                                        name="end"
                                                        type="date"
                                                        value={disp?.end}
                                                        onChange={(e) => {
                                                            // console.log('first', e.target?.value) 
                                                            let o = [...disponiblite];
                                                            let m = { ...disp };
                                                            m.end = e.target?.value
                                                            o[index] = m;
                                                            setDisponibilite(o);
                                                            let d = { ...formd };
                                                            d['disponibilite'] = o;
                                                            setFrom(d);
                                                        }} placeholder='Choisir...' />
                                                </Form.Group>

                                                <IconButton as={Col} md="1" onClick={() => {
                                                    let arr = disponiblite;
                                                    arr.splice(index, 1);
                                                    setDisponibilite(arr);
                                                    let d = { ...formd };
                                                    d['disponibilite'] = arr;
                                                    setFrom(d);
                                                }}
                                                    variant="falcon-danger"
                                                    size="sm"
                                                    icon="trash"
                                                    transform="shrink-3"
                                                    className='me-2'
                                                    style={{ width: 60, height: 25, marginTop: 35 }}
                                                >
                                                </IconButton>
                                            </Row>)
                                        })
                                    }

                                    <div>
                                        <Flex
                                            alignItems="center"
                                            className="mb-4 text-primary cursor-pointer fs-0"
                                            onClick={() => {
                                                let o = [...disponiblite];
                                                if (o[o.length - 1]?.first !== null && o[o.length - 1]?.end !== null) {
                                                    o.push({ first: null, end: null });
                                                    setDisponibilite(o);
                                                }
                                            }}
                                        >
                                            <span className="circle-dashed">
                                                <FontAwesomeIcon icon="plus" />
                                            </span>
                                            <span className="ms-3">Ajouter une nouvelle période de disponibilité</span>
                                        </Flex>
                                    </div>

                                    {services[services.length - 1]?.service === null && (
                                        <Form.Text className="text-warning fs--1">
                                            <p>pas dans la liste, <a target="_blank" href="/service/new">Ajouté</a> <IconButton
                                                variant="falcon-default"
                                                size="sm"
                                                icon="reload"
                                                className="me-1 mb-2 mb-sm-0"
                                                iconClassName="me-1"
                                                onClick={() => { loadList() }}>
                                                recharger la liste des services
                                            </IconButton></p>


                                        </Form.Text>
                                    )}



                                </Row>

                                <hr style={{ marginTop: 10 }} />

                                <Form.Group as={Col} md="11" controlId="calendarId">
                                    <Form.Label>Identifiant calendrier Google</Form.Label>
                                    <Form.Control
                                        minlength="3"
                                        type="text"
                                        value={formd.calendarId}
                                        name="calendarId"
                                        onChange={handleChange}
                                        placeholder="Demander l'identifiant au dev..."
                                    />
                                    <Form.Text className="text-warning fs--1">
                                        ⚠️ Modifier cette donnée peut rompre le fonctionnement du site
                                    </Form.Text>
                                    <br />
                                    {formd.calendarId && <Form.Text className="text-primary fs--1">Lien public : https://calendar.google.com/calendar/ical/{formd.calendarId.replace('@', '%40')}/public/basic.ics</Form.Text>}

                                </Form.Group>

                                {caA && formd.calendarId === null ? <p>Chargement...</p> : <a onClick={() => { creatandAsign() }}>Créer et assigner un nouveau calendrier google à la propriété</a>}
                                <hr />

                                <Form.Group as={Col} md="4" controlId="localisation.lat">
                                    <Form.Label>Localisation latitude <Badge>wordpress</Badge></Form.Label>
                                    <Form.Control
                                        minlength="3"
                                        type="text"
                                        value={formd?.lat}
                                        name="lat"
                                        onChange={handleChange}
                                        placeholder="Latitude du bien..."
                                    />
                                    <Form.Text className="text-primary fs--1">
                                        informations utilisées pour afficher la propriété sur une carte pour les partenaires
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} md="4" controlId="localisation.long">
                                    <Form.Label>Localisation longitude <Badge>wordpress</Badge></Form.Label>
                                    <Form.Control
                                        minlength="3"
                                        type="text"
                                        value={formd?.long}
                                        name="long"
                                        onChange={handleChange}
                                        placeholder="Longitude du bien..."
                                    />
                                    <Form.Text className="text-primary fs--1">
                                        Utiliser ce site pour récupéré la latitude et longitude du bien <a href='https://www.latlong.net' target='_blank'>https://www.latlong.net</a>
                                    </Form.Text>
                                </Form.Group>

                                <hr className="mt-3" />
                                <Form.Group className="mb-3">
                                    <Form.Label>Description <Badge>wordpress</Badge></Form.Label>

                                    <Form.Control as="textarea" name="description"
                                        placeholder="Laisser une description ici"
                                        style={{ height: '100px' }}
                                        value={formd.description}
                                        onChange={handleChange}
                                    />
                                </Form.Group>


                                <Form.Group className="mb-3">
                                    <Form.Label>Description (Anglais) <Badge>wordpress</Badge></Form.Label>

                                    <Form.Control as="textarea" name="description_en"
                                        placeholder="Leave a description here..."
                                        style={{ height: '100px' }}
                                        value={formd.description_en}
                                        onChange={handleChange}
                                    />
                                </Form.Group>

                                <hr className="mt-3" />
                                <Form.Group className="mb-3">
                                    <Form.Label>Détails des pièces</Form.Label>
                                    <Form.Control as="textarea" name="detailpiece"
                                        placeholder="Nécessaire pour le contrat de location"
                                        style={{ height: '100px' }}
                                        value={formd.detailpiece}
                                        onChange={handleChange}
                                    />
                                </Form.Group>

                                <hr className="mt-3" />
                                <Form.Group className="mb-3">
                                    <Form.Label>Commentaire</Form.Label>

                                    <Form.Control as="textarea" name="comment"
                                        placeholder="Laisser un commentaire ici (interne)"
                                        style={{ height: '100px' }}
                                        value={formd.comment}
                                        onChange={handleChange}
                                    />
                                </Form.Group>

                                <hr />

                                <Form.Group as={Col} md="10" controlId="otaId">
                                    <Form.Label>Identifiants OTA</Form.Label>
                                    <Select
                                        closeMenuOnSelect={false}
                                        isMulti
                                        options={[
                                            { value: "67E36287euue", label: "demo | Airbnb - Alma" },
                                            { value: "fbeiz dez", label: "demo | Booking - Alma" },
                                            { value: "fbeiz efzf", label: "demo | Abritel - Alma" },
                                            { value: "fbeefz", label: "demo | Airbnb - Vallée du golf" },
                                            { value: "fbeizdez", label: "demo | Booking - Vallée du golf" },
                                            { value: "fbeizefzf", label: "demo | Abritel - Vallée du golf" }
                                        ]}
                                        placeholder='Choisir les connexions ota...'
                                        classNamePrefix="react-select"
                                        value={valueOTA}
                                        onChange={value => {
                                            setValueOTA(value)
                                            let d = formd;
                                            d['otaIds'] = value;
                                            setFrom(d);

                                        }}
                                    />

                                    <Form.Text className="text-warning fs--1">
                                        Informations utilisées pour se lié aux OTA (pas dans la liste, contacter le dev)
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} md="10" controlId="equipment">
                                    <Form.Label>Equipement <Badge>wordpress</Badge></Form.Label>
                                    <Select
                                        closeMenuOnSelect={false}
                                        isMulti
                                        options={equipements}
                                        placeholder='Choisir les équipements ...'
                                        classNamePrefix="react-select"
                                        value={valueEquipment}
                                        onChange={value => {
                                            setValueEquipment(value)
                                            let d = formd;
                                            d['equipments'] = value;
                                            setFrom(d);
                                        }}
                                    />

                                    <Form.Text className="text-warning fs--1">
                                        <p>pas dans la liste, <a target="_blank" href="/equiment/new">Ajouté</a> <IconButton
                                            variant="falcon-default"
                                            size="sm"
                                            icon="reload"
                                            className="me-1 mb-2 mb-sm-0"
                                            iconClassName="me-1"
                                            onClick={() => { loadList() }}>
                                            recharger la liste d'equipement
                                        </IconButton></p>


                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} md="10" controlId="equipment">
                                    <Form.Label>Equipement en avant <Badge>NEW 4 maximum</Badge></Form.Label>
                                    <Select
                                        closeMenuOnSelect={false}
                                        isMulti
                                        isOptionDisabled={(option) => valueEquipmentEnAvant.length >= 4}
                                        options={equipements}
                                        placeholder='Choisir les équipements ...'
                                        classNamePrefix="react-select"
                                        value={valueEquipmentEnAvant}
                                        onChange={value => {
                                            setValueEquipmentEnAvant(value)
                                            let d = formd;
                                            d['equipmentsInFavorites'] = value;
                                            setFrom(d);
                                        }}
                                    /> 
                                </Form.Group>


                                <Form.Group as={Col} md="10" controlId="contactsId">
                                    <Form.Label>Contacts</Form.Label>
                                    <Select
                                        closeMenuOnSelect={false}
                                        isMulti
                                        options={clients}
                                        placeholder='Choisir les contacts ...'
                                        classNamePrefix="react-select"
                                        value={valueContacts}
                                        onChange={value => {
                                            setValueContactsId(value)
                                            let d = formd;
                                            d['contactsId'] = value;
                                            setFrom(d);
                                        }}
                                    />

                                </Form.Group>
                                <Form.Text className="text-primary fs--1">
                                    Liste du CRM (pas dans la liste, ajouté votre contact dans le CRM puis assigné le ici)
                                </Form.Text>


                                <Form.Group as={Col} md="10" controlId="infoFilePDF">
                                    <Form.Label>Fiche d'information (PDF)</Form.Label>
                                    <Form.Control type="file" name="infoFilePDF" accept="application/pdf"
                                        onChange={(value) => {
                                            console.log("infoFilePDF", value?.target?.files)
                                            setNewInfoFile(value?.target?.files)
                                        }}
                                    />
                                </Form.Group>
                                {formd?.newInfofile && (
                                    <Col xs={2}>
                                        <Form.Label>Fiche d'information </Form.Label>
                                        <p style={{ textAlign: 'center' }}> <a href={formd?.newInfofile} target='_blank'>Voir le fichier</a></p>
                                    </Col>)}

                            </Row>


                            <Row>
                                <Col xs={2}>
                                    <Button type="submit" disabled={l}>{l ? 'Chargement' : 'Modifier'}</Button>
                                </Col>
                                {/* ajouter une checkbox de form quand on clique dessus j'affiche une modal */}
                                <Col xs={3}>
                                    <Form.Check
                                        type="checkbox"
                                        id="custom-checkbox"
                                        checked={sync}
                                        label="Synchoniser avec votre site WordPress"
                                        onChange={(e) => {
                                            setSync(e.target.checked)
                                            setShow(e.target.checked)
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Form>
                    </FalconComponentCard.Body>

                    <Modal show={show} onHide={handleClose} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Configuration avec votre site WordPress</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <Alert variant='info'>
                                <Alert.Heading>Modification de la villa</Alert.Heading>
                                <p>Si la page de la villa sur WordPress est ouverte par un tiers, la mise à jour sera bloquée par WordPress. Veuillez donc fermer toutes les pages ayant la villa sélectionnée ouverte.</p>
                            </Alert>
                            <Form>
                                {/* Sélection de la villa */}
                                <Form.Group controlId="villaSelect">
                                    <Form.Label>Identifiant WordPress</Form.Label>
                                    {villas.length > 0 ? (<Form.Control
                                        as="select"
                                        value={selectedVilla}
                                        onChange={handleVillaChange}
                                    >
                                        <option value="">Sélectionnez une villa</option>
                                        {villas.map((villa) => (
                                            <option key={villa.id} value={villa.id}>
                                                {villa.title} (id: {villa.id})
                                            </option>
                                        ))}
                                    </Form.Control>) : ('Chargement ...')}

                                </Form.Group>
                                {!syncPriceDemand && (<span style={{ fontSize: 9 }}>Le tarif sera initialisé avec le tableau dynamique de prix s'il est à 0 </span>)}

                                <Form.Check
                                    type="checkbox"
                                    id="custom-checkbox-priceondemand"
                                    checked={syncPriceDemand}
                                    label="Prix sur demande"
                                    onChange={(e) => {
                                        setSyncPriceDemand(e.target.checked)
                                    }}
                                />
                                {!syncPriceDemand && <>
                                    <Form.Check
                                        type="checkbox"
                                        id="custom-checkbox-price"
                                        checked={syncPrice}
                                        label="Synchoniser les tarifs"
                                        onChange={(e) => {
                                            setSyncPrice(e.target.checked)
                                        }}
                                    />
                                </>}





                                {/* Champs affichés uniquement si une villa est sélectionnée */}
                                {selectedVilla && (
                                    <>
                                        {/* Sélection de la synchronisation des photos */}
                                        <Form.Group controlId="syncPhotos">
                                            <Form.Label>Synchroniser les photos</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={syncPhotos}
                                                onChange={handleSyncChange}
                                            >
                                                <option value="">Sélectionnez une option</option>
                                                <option value="no">Non</option>
                                                <option value="merge">Fusionner</option>
                                                <option value="replace">Uniquement les photos du logiciel</option>
                                            </Form.Control>
                                        </Form.Group>

                                        {/* Alerte affichée si l'option "Uniquement les photos du logiciel" est choisie */}
                                        {syncPhotos === "replace" && (
                                            <Alert variant="danger" className="mt-3">
                                                ⚠️ Attention : Toutes les photos actuelles liées à la villa sélectionnée seront supprimées et remplacées.
                                                {/* La première photo deviendra la photo de garde. */}
                                            </Alert>
                                        )}
                                        {syncPhotos === "merge" && (
                                            <Alert variant="danger" className="mt-3">
                                                ⚠️ Attention : Toutes les photos du logiciel seront ajouté à la fin des photos déjà existante
                                            </Alert>
                                        )}
                                    </>
                                )}

                                <Form.Check
                                    type="checkbox"
                                    id="custom-checkbox-cover"
                                    checked={syncCover}
                                    label="Changer la cover par la première image de la gallerie"
                                    onChange={(e) => {
                                        setSyncCover(e.target.checked)
                                    }}
                                />

                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Fermer
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Card className="mt-3">
                        <FalconCardHeader title="Modifier la gallerie" light />


                        <Card.Body>
                            {visibleGallery && gallery && gallery.length > 0 && (
                                <div style={{ marginBottom: 20 }}>
                                    <IconButton
                                        variant="falcon-danger"
                                        size="sm"
                                        icon="reload"
                                        className="me-1 mb-2 mb-sm-0"
                                        iconClassName="me-1"
                                        onClick={() => {
                                            if (confirm("Supprimer toutes les photos ? ")) {
                                                setLPhoto(true)
                                                firebase.firestore().collection('properties').doc(id).update({ gallery: [] }).then((snap) => {
                                                    var f = { ...formd }
                                                    f.gallery = []
                                                    setFrom(f)
                                                    setGallery([])
                                                    setLPhoto(false)
                                                    toast.success('Photos supprimé');
                                                }).catch((err) => {
                                                    toast.error(err)
                                                })
                                            }
                                        }}>
                                        Supprimer toutes les photos
                                    </IconButton>

                                    <IconButton
                                        variant="falcon-primary"
                                        size="sm"
                                        icon="reload"
                                        className="me-1 mb-2 mb-sm-0"
                                        iconClassName="me-1"
                                        onClick={() => {
                                            handleModalShow()
                                        }}>
                                        Modifier les photos en preview  <Badge>wordpress</Badge>
                                    </IconButton>
                                </div>
                            )}

                            {/* La modale */}
                            <Modal show={showModal} onHide={handleModalClose}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Modifier les photos</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {previews.length > 0 ? (<Row className="g-2">
                                        <ReactSortable className="g-2 row" list={previews} setList={(newState) => { setPreviews(newState) }} direction={'horizontal'}>
                                            {/* <Row > */}
                                            {previews && previews?.map((image, i) => {
                                                return (
                                                    <Col xs={4}>
                                                        <Image
                                                            className="cursor-pointer"
                                                            src={image}
                                                            fluid
                                                            rounded
                                                        />
                                                    </Col>)
                                            })}
                                        </ReactSortable>
                                    </Row>
                                    ) : (
                                        <div className="d-flex flex-wrap">
                                            {!lgallery && gallery?.map((photo, index) => (
                                                <Col xs={4} key={index} className="position-relative mb-3">
                                                    <Image
                                                        className="cursor-pointer"
                                                        src={photo}
                                                        fluid
                                                        rounded
                                                        style={{
                                                            opacity: selectedPhotos.includes(photo) ? 1 : 0.3, // Opacité en fonction de la sélection
                                                        }}
                                                        onClick={() => handleSelectPhoto(photo)} // Clique pour sélectionner/désélectionner
                                                    />
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={selectedPhotos.includes(photo)} // Case cochée si la photo est sélectionnée
                                                        onChange={() => handleSelectPhoto(photo)} // Gère le changement d'état
                                                        className="position-absolute top-0 start-0 m-2" // Positionne la case à cocher
                                                    />
                                                </Col>
                                            ))}
                                        </div>
                                    )}

                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleModalClose}>
                                        Fermer
                                    </Button>
                                    {previews.length > 0 && (
                                        <Button variant="secondary" onClick={() => {
                                            const pm = [...previews]
                                            setSelectedPhotos(pm)
                                            setPreviews([])
                                        }}>
                                            Modifier la previews
                                        </Button>
                                    )}

                                    <Button variant="primary" onClick={() => {
                                        if (previews.length > 0) {
                                            let d = { ...formd };
                                            d.previews = previews;
                                            setFrom(d);
                                            handleModalClose()
                                        } else {
                                            if (selectedPhotos.length > 0) {

                                                const uniquePreviews = selectedPhotos.filter((image, index, self) =>
                                                    index === self.findIndex((t) => (
                                                        t === image
                                                    ))
                                                );
                                                setPreviews(uniquePreviews);
                                            } else {
                                                alert('Choisir des photos de previews');
                                            }
                                        }
                                    }}>
                                        {previews.length > 0 ? 'Appliquer les modifications' : 'Choisir les photos'}
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Row className="g-2">
                                {!visibleGallery && (<Button variant="secondary" onClick={() => { setVisibleGallery(true) }}>
                                    voir les photos de la gallery
                                </Button>)}
                                {visibleGallery && (
                                    <Col xs={4}>
                                        <Form noValidate validated={validated} onSubmit={handleSubmitPicture} >
                                            <Form.Control type="file" name="picture" multiple accept="image/png, image/gif, image/jpeg"
                                                onChange={(value) => {
                                                    setNewGallery(value?.target?.files)
                                                }}
                                            />
                                            {lphoto && <>
                                                <br />
                                                <p>Analyse et envoie en cours, patientez</p>
                                                <ProgressBar now={progress} label={`${uploaded} / ${Array.from(newgallery).length}`} />

                                            </>}

                                            <Button color="primary" disabled={lphoto || newgallery.length === 0} type="submit" className="px-5 my-3">
                                                {lphoto ? "Chargement.." : "Ajouter à la gallerie"}
                                            </Button>
                                        </Form>
                                    </Col>
                                )}


                                {lphoto && (<Row className="g-2">
                                    {Array.from(newgallery).slice(0, 5).map(() => {
                                        return (<Col xs={2}>
                                            <div className="shimmer-placeholder" />
                                        </Col>)
                                    })}

                                </Row>)}


                                {visibleGallery && <ReactSortable className="g-2 row" list={gallery} setList={(newState) => { setGallery(newState); updateG(newState) }} direction={'horizontal'}>
                                    {/* <Row > */}
                                    {!lgallery && gallery?.map((image, i) => {
                                        return (
                                            <Col xs={2}>
                                                <Image
                                                    className="cursor-pointer"
                                                    src={image}
                                                    fluid
                                                    rounded
                                                />
                                                <p style={{ textAlign: 'center' }}><a style={{ color: 'red' }} onClick={() => { delImage(i) }} >Supprimer</a></p>
                                            </Col>)
                                    })}
                                    {/* </Row> */}
                                </ReactSortable>}


                            </Row>


                        </Card.Body>
                    </Card>


                    {visibleGallery && (
                        <Card className="mt-3">
                            <FalconCardHeader title="Fichiers" light />
                            <Card.Body>
                                <Row className="g-2">
                                    <Col xs={4}>
                                        <Form noValidate validated={validated} onSubmit={handleSubmitFile} >
                                            <Form.Control type="file" name="file" multiple
                                                onChange={(value) => {
                                                    console.log("file", value?.target?.files)
                                                    setNewFile(value?.target?.files)
                                                }}
                                            />
                                            <Button color="primary" disabled={lfile || newfile.length === 0} type="submit" className="px-5 my-3">
                                                {lfile ? "Chargement.." : "Ajouter les fichiers"}
                                            </Button>
                                        </Form>
                                    </Col>
                                    {!lfile && files?.map((f, i) => {
                                        return (
                                            <Col xs={2}>
                                                <p style={{ textAlign: 'center' }}> <a href={f} target='_blank'>Voir le fichier</a></p>
                                                {/* <Image
                                        className="cursor-pointer"
                                        src={image}
                                        fluid
                                        rounded 
                                        onClick={() => {}} 
                                />*/}
                                                <p style={{ textAlign: 'center' }}><a style={{ color: 'red' }} onClick={() => { delFile(i) }} >Supprimer</a></p>
                                            </Col>)
                                    })}
                                </Row>
                            </Card.Body>
                        </Card>
                    )}


                    {/* {visibleGallery && (<GPhotos title={"Photos de la propriété"} images={formd?.gallery} />)} */}

                </>)
            }
        </FalconComponentCard>
    );
};

export default EditVilla;
